// Authentication utilities
console.log('🚀 [auth.js] Ładowanie modułu auth.js');

import { useState, useEffect } from 'react';
import { api } from './api';

console.log('✅ [auth.js] Importy załadowane');

// Hook to check if user is authenticated (uses httpOnly cookie via API)
export function useAuth() {
  console.log('🔐 [auth.js] Hook useAuth() wywołany');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    checkAuth();
  }, []);
  
  const checkAuth = async () => {
    console.log('🔍 [auth.js] Sprawdzanie autoryzacji...');
    try {
      const data = await api.get('/api-me');
      console.log('✅ [auth.js] Użytkownik zalogowany:', data.user);
      setUser(data.user);
      setIsAuthenticated(true);
    } catch (error) {
      console.warn('⚠️ [auth.js] Użytkownik niezalogowany:', error.message);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      console.log('✅ [auth.js] Sprawdzanie zakończone');
      setLoading(false);
    }
  };
  
  return { isAuthenticated, loading, user };
}

// Logout function - calls server to clear httpOnly cookie
export async function logout() {
  try {
    await api.post('/logout');
  } catch (error) {
    console.error('Logout error:', error);
  }
}
